import { render, staticRenderFns } from "./BimDemolitionArea.vue.html?vue&type=template&id=2a6903f6&lang=html&external"
import script from "./BimDemolitionArea.vue.js?vue&type=script&lang=js&external"
export * from "./BimDemolitionArea.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDemolitionArea.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports